import { Navigate } from '@tanstack/react-router'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Protect } from '@clerk/clerk-react'

export const Route = createFileRoute('/_authenticated/_admin')({
  component: AdminLayoutRoute,
})

function AdminLayoutRoute() {
  return (
    <Protect
      condition={(has) =>
        has({ role: 'org:admin' }) ||
        has({ role: 'org:super_admin' }) ||
        has({ role: 'org:claims_adjuster' }) ||
        has({ role: 'org:finance_admin' })
      }
      fallback={<Navigate to='/403' />}
    >
      <Outlet />
    </Protect>
  )
}
